import * as React from "react";
import { forwardRef } from "react";
const SvgDragHandle = (props, ref) => /* @__PURE__ */ React.createElement("svg", {
	fill: "none",
	height: "1em",
	viewBox: "0 0 8 4",
	width: "1em",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props
}, /* @__PURE__ */ React.createElement("path", {
	d: "M0.25 0C0.183696 0 0.120107 0.052678 0.0732234 0.146446C0.0263393 0.240214 0 0.367392 0 0.5C0 0.632608 0.0263393 0.759786 0.0732234 0.853554C0.120107 0.947322 0.183696 1 0.25 1H7.75C7.8163 1 7.87989 0.947322 7.92678 0.853554C7.97366 0.759786 8 0.632608 8 0.5C8 0.367392 7.97366 0.240214 7.92678 0.146446C7.87989 0.052678 7.8163 0 7.75 0H0.25ZM0.25 3C0.183696 3 0.120107 3.05268 0.0732234 3.14645C0.0263393 3.24021 0 3.36739 0 3.5C0 3.63261 0.0263393 3.75979 0.0732234 3.85355C0.120107 3.94732 0.183696 4 0.25 4H7.75C7.8163 4 7.87989 3.94732 7.92678 3.85355C7.97366 3.75979 8 3.63261 8 3.5C8 3.36739 7.97366 3.24021 7.92678 3.14645C7.87989 3.05268 7.8163 3 7.75 3H0.25Z",
	fill: "currentColor"
}));
const ForwardRef = forwardRef(SvgDragHandle);
export default ForwardRef;
